import api from './api';

const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

// Serviços agora são USER-LEVEL (catálogo do usuário)
// Não pertencem mais a profissionais
const servicesService = {
  // Retorna todos os serviços do usuário
  async getAll() {
    const response = await api.get('/services');
    return extractData(response.data);
  },

  // Buscar serviço por ID
  async getById(id) {
    const response = await api.get(`/services/${id}`);
    return extractData(response.data);
  },

  // Criar novo serviço (catálogo do usuário)
  async create(data) {
    const response = await api.post('/services', data);
    return extractData(response.data);
  },

  // Atualizar serviço
  async update(id, data) {
    const response = await api.put(`/services/${id}`, data);
    return extractData(response.data);
  },

  // Deletar serviço
  // ✅ Validação happens in API (isInUseAsync)
  // Se houver erro (400), a exceção vai ser lançada pelo axios
  // Quem chama trata o erro
  async delete(id) {
    await api.delete(`/services/${id}`);
    // Se chegou aqui, foi sucesso (204 No Content)
  },
};

export default servicesService;
